import { motion } from "framer-motion";
import React, { useRef, useState, useContext } from "react";
import { validate } from "validate.js";
import EventRegistrationTypeWriter from "./EventRegistrationTypeWriter";
import { EventsContext } from "../../EventsContext";
import { useParams } from "react-router-dom";
import { initializeApp } from "firebase/app";
import { Link } from 'react-router-dom' 
import { useNavigate } from "react-router-dom";

 
// import {
//   getFirestore,
//   collection,
//   getDocs,
//   doc,
//   setDoc,
//   addDoc,
// } from "firebase/firestore/lite";
import "./Form.css";

import { db } from "../../firebase";
import { collection, addDoc, Timestamp } from "firebase/firestore";

const EventRegistrationForm = (props) => {
  const { id } = useParams();
  console.log("fadsfs",id)
  const navigate = useNavigate();
  var paymentUrl = "https://rzp.io/l/JDTVjuEiER";
  if (id > 10) {
    paymentUrl = "https://rzp.io/l/jjIjs3O";
  } 
  const departments = [
    "Mechanical Engineering",
    "Mechatronics Engineering",
    "Electrical & Electronics Engineering",
    "Electronics and Communication Engineering",
    "Biomedical Engineering",
    "Computer Science and Engineering",
    "Information Technology",
    "Artificial Integlligence and Data Science",
    "Fashion Technology",
    "Civil Engineering",
  ];

  const event = useContext(EventsContext);

  const errorsDefault = {
    name: [],
    email: [],
    phone: [],
    regno: [],
    year: [],
    department: [],
    college: [],
  };

  const formRef = useRef();
  const [formErrors, setformErrors] = useState(errorsDefault);

  const validationRules = {
    name: {
      presence: { allowEmpty: false },
      length: {
        minimum: 2,
        maximum: 128,
      },
    },
    email: {
      presence: { allowEmpty: false },
      email: true,
    },
    phone: {
      presence: { allowEmpty: false },
      format: {
        pattern: "[0-9]{10}",
        message: "Must be a valid phone number !",
      },
    },
    year: {
      presence: { allowEmpty: false, message: "Year can't be blank" },
      inclusion: {
        within: ["1", "2", "3", "4"],
        message: "Year cannot be blank !",
      },
    },
    department: {
      presence: { allowEmpty: false, message: "Department can't be blank" },
      inclusion: {
        within: departments,
        message: "Department cannot be blank !",
      },
    },
    college: {
      presence: { allowEmpty: false, message: "College Name can't be blank" },
    },
  };
  // const firebaseConfig = {
  //   apiKey: "AIzaSyCZRWhePnY8wpRy57IjgZaPilFK-z3JplQ",
  //   authDomain: "threads22-cb396.firebaseapp.com",
  //   projectId: "threads22-cb396",
  //   storageBucket: "threads22-cb396.appspot.com",
  //   messagingSenderId: "1088732062082",
  //   appId: "1:1088732062082:web:c5a5a9e0ccbfc819a2ef9b",
  // };

  // const app = initializeApp(firebaseConfig);
  // const db = getFirestore(app);
  async function createUser(db, formData,event) {
    const userDoc = collection(db, "users");
    console.log(formData);
    var userData = { ...formData };
    // userData.eventTransactionId = "";
    // userData.workshopTransactionId = "";
    // userData.paidForEvents = false;
    // userData.paidForWorkshops = false;
    if(event==="1"){
      await addDoc(userDoc, userData).then(
        (res) => {
          console.log(res);
          window.location.replace(paymentUrl);
        },
        (err) => {
          console.log(err);
        }
      );
      navigate("/", { replace: true });
    }
    else{
      await addDoc(userDoc, userData).then(
        (res) => {
          console.log(res);
        },
        (err) => {
          console.log(err);
        }
      );
      navigate("/", { replace: true });
    }
  }
  // const db = firebase.collection("/users");
  const getWorkshopName = () =>{
    if(id==="11"){
      return "RPA"
    }
    else if(id==="12"){
      return "APP"
    }
    else if(id==="13"){
      return "IOT"
    }
  }

  const submitHandler = (e) => {
    e.preventDefault();
    var event = e.nativeEvent.submitter.id

    const formData = validate.collectFormValues(formRef.current);
    const errors = validate(formData, validationRules);
    var Workshop =  getWorkshopName()
    formData["Event"] = Workshop
    console.log(formData)
    if (errors) {
      setformErrors(errors);
    } else {
      console.log("dsafdasf")
      createUser(db, formData,event);
      setformErrors(errorsDefault);
    }
    // db.add(formData)
    //   .then(() => {
    //     console.log("Created new item successfully!");
    //     this.setState({
    //       submitted: true,
    //     });
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });
    // createUser(db, formData);
  };

  return (
    <div className="page-wrapper bg-gra-01 p-t-180 p-b-100 font-poppins">
      <div className="wrapper wrapper--w960">
        <div className="card card-3">
          <div
            className="card-heading image_Form"
            style={{
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          ></div>
          <div className="card-body">
            <h2 className="description card-heading">
              <EventRegistrationTypeWriter />
            </h2>
            <form ref={formRef} onSubmit={submitHandler}>
              <div className="input-group">
                <motion.input
                  name="name"
                  className="input--style-3"
                  type="text"
                  placeholder="Name"
                  whileHover={{ scale: 1.2 }}
                  whileTap={{ scale: 0.8 }}
                />
                {formErrors["name"] ? (
                  formErrors.name.map((error) => (
                    <motion.small
                      key={error}
                      className="text-red-500"
                      animate={{ scale: [1, 2, 1] }}
                      transition={{ duration: 2, delay: 0.5 }}
                    >
                      {error}
                    </motion.small>
                  ))
                ) : (
                  <></>
                )}
              </div>
              <div className="input-group">
                <motion.input
                  name="email"
                  type="email"
                  className="input--style-3"
                  placeholder="Email"
                  whileHover={{ scale: 1.2 }}
                  whileTap={{ scale: 0.8 }}
                />
                {formErrors["email"] ? (
                  formErrors.email.map((error) => (
                    <small key={error} className="text-red-500">
                      {error}
                    </small>
                  ))
                ) : (
                  <></>
                )}
              </div>
              <div className="input-group">
                <motion.input
                  name="phone"
                  className="input--style-3"
                  type="text"
                  placeholder="Phone Number"
                  whileHover={{ scale: 1.2 }}
                  whileTap={{ scale: 0.8 }}
                />
                {formErrors["phone"] ? (
                  formErrors.phone.map((error) => (
                    <small key={error} className="text-red-500">
                      {error}
                    </small>
                  ))
                ) : (
                  <></>
                )}
              </div>
              {/* <div className="input-group">
                <motion.input
                  name="regno"
                  className="input--style-3"
                  type="text"
                  placeholder="Reg No"
                  whileHover={{ scale: 1.2 }}
                  whileTap={{ scale: 0.8 }}
                />
                {formErrors["regno"] ? (
                  formErrors.regno.map((error) => (
                    <small key={error} className={"text-red-500"}>
                      {error}
                    </small>
                  ))
                ) : (
                  <></>
                )}
              </div> */}
              <div className="input-group">
                <div className="rs-select2 js-select-simple select--no-search">
                  <motion.select
                    name="year"
                    className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    whileHover={{ scale: 1.2 }}
                    whileTap={{ scale: 0.8 }}
                  >
                    <option value="1">1st Year</option>
                    <option value="2">2nd Year</option>
                    <option value="3">3rd Year</option>
                    <option value="4">4th Year</option>
                  </motion.select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                  {formErrors["year"] ? (
                    formErrors.year.map((error) => (
                      <small key={error} className="text-red-500">
                        {error}
                      </small>
                    ))
                  ) : (
                    <></>
                  )}

                  <div className="select-dropdown"></div>
                </div>
              </div>
              <div className="input-group">
                <div className="rs-select2 js-select-simple select--no-search">
                  <motion.select
                    name="department"
                    className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="dept-inp"
                    whileHover={{ scale: 1.2 }}
                    whileTap={{ scale: 0.8 }}
                  >
                    {departments.map((department) => (
                      <option key={department} value={department}>
                        {department}
                      </option>
                    ))}
                  </motion.select>
                  <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                      class="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="input-group">
                <input
                  className="input--style-3"
                  type="text"
                  placeholder="College Name"
                  name="college"
                />
                {formErrors["college"] ? (
                  formErrors.college.map((error) => (
                    <small key={error} className="text-red-500">
                      {error}
                    </small>
                  ))
                ) : (
                  <></>
                )}
              </div>
              <div className="p-t-10">
                <button className="Button_Form Margin_Form" id="0" type="submit">
                  Pay Later
                </button>
                <label className="blinker Margin_Form"> or </label>
                <button className="Button_Form Margin_Form" id="1" type="submit">
                  Pay Now
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventRegistrationForm;
